import 'bootstrap/dist/css/bootstrap.min.css'
import DataTable from 'react-data-table-component'
import { Container, Row, Col, Button } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import TableStyle from '../Misc/TableStyle'
import { TextInput } from '../Misc/FormInput'
import { useNavigate } from 'react-router-dom'
import { authFetch } from '../Auth/apiClient'
import { useMsal } from '@azure/msal-react';

function formatCampaignName(name, year, startDate, endDate) {
    // If year field exists, generate new format from year and dates
    if (year && startDate && endDate) {
        const start = new Date(startDate + 'T00:00:00');
        const end = new Date(endDate + 'T00:00:00');
        const startFormatted = `${String(start.getMonth() + 1).padStart(2, '0')}.${String(start.getDate()).padStart(2, '0')}.${String(start.getFullYear()).slice(-2)}`;
        const endFormatted = `${String(end.getMonth() + 1).padStart(2, '0')}.${String(end.getDate()).padStart(2, '0')}.${String(end.getFullYear()).slice(-2)}`;
        
        // Extract description from name (remove year/dates if present)
        //const description = name.replace(/^\d{4}_/, '').replace(/_\d{6}-\d{6}$/, '').replace(/_/g, ' ');
        
        return `${year} - (${startFormatted}-${endFormatted}) - ${name}`;
    }
    
    // Parse old format and convert
    const match = name.match(/^(\d{4})_(.*?)[-_](\d{6})-(\d{6})$/);
    if (match) {
        const yearFromName = match[1];
        const description = match[2];
        const startDateStr = match[3];
        const endDateStr = match[4];
        
        const startFormatted = `${startDateStr.slice(0,2)}.${startDateStr.slice(2,4)}.${startDateStr.slice(4)}`;
        const endFormatted = `${endDateStr.slice(0,2)}.${endDateStr.slice(2,4)}.${endDateStr.slice(4)}`;
        
        return `${yearFromName} - (${startFormatted}-${endFormatted}) - ${description}`;
    }
    
    return name;
}


const CampaignTable = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();

    const columns = [
        {
            name: 'Name',
            //selector: row => row.name,
            selector: row => formatCampaignName(row.name, row.year, row.startDate, row.endDate),
            sortable: true,
            width: "50%"
        },
        {
            name: 'Last Modified',
            selector: row => row.modifiedDate.split('.')[0],
            /*cell: row => {() => {let date = new Date(Date.parse(row.modifiedDate));return date;}},*/
            sortable: true,
            width: "20%",
        },
        {
            name: 'Start Date',
            selector: row => row.startDate,
            sortable: true,
            width: "15%"
        },
        {
            name: 'End Date',
            selector: row => row.endDate,
            sortable: true,
            width: "15%"
        },
        {
            name: 'Selector',
            cell: row => <Link to={{pathname: '/edit_campaign', name:`${row.name}`, campaignStartDate:row.startDate, campaignEndDate:row.endDate, pages:row.pages, template:row.template, campaignProducts: row.products, year: row.year}} style={{display: 'none'}} id={`editCampaignLink${row.name}`}></Link>,
            omit: true
        }
    ]

    const [campaigns, setCampaigns] = useState([]);
    useEffect(() => {
        authFetch(instance, '/api/fetch_campaigns')
            .then((res) => {
                return res.json();
            })
            .then((data) => {
                setCampaigns(data);
                console.log(data);
                //console.log(campaigns);
            })
            .catch(function(error) {
                alert('There was an error connecting to the database, please refresh the page.');
            });
    }, []);

    
    const [searchTerm, setSearchTerm] = useState('');

    return (
        <Container>
            <Row>
                <Col xs={4} className="text-start">
                    <h2>Campaigns</h2>
                </Col>
                <Col xs={2} className="text-end align-self-center offset-6 d-grid">
                {/*<Link to={{pathname: "/new_campaign"}}
                    style={{backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21", padding: "5px 10px"}}>Create New Campaign</Link>*/}
                <Button
                    style={{backgroundColor: "#a73c21", color: "#ffffff", textDecoration: "underline #a73c21", borderRadius: "0px",
                    borderColor: "#a73c21"}}
                    onClick={() => navigate('/new_campaign')}
                >Create New Campaign</Button>
                </Col>
            </Row>
            <hr />
            <Row>
                <Col xs={6} className="text-end">
                <TextInput placeholder="Start typing to filter campaigns..." inputName="searchTerm" inputLabel="Filter:" inputValue={searchTerm} changeFunc={(event) => setSearchTerm(event.target.value)}/>
                </Col>
            </Row>
            <DataTable
                columns={columns}
                data={campaigns.filter((campaign) => {
                    if (searchTerm === "") {
                        return campaign;
                      } else if (campaign.name.toLowerCase().includes(searchTerm.toLowerCase()) || campaign.startDate.toLowerCase().includes(searchTerm.toLowerCase()) || campaign.endDate.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return campaign;
                      /*||
                      campaign.template.toLowerCase().includes(searchTerm.toLowerCase())) {
                      return campaign;*/
                      } else {
                          return null;
                      }
                })}
                defaultSortFieldId={2}
                defaultSortAsc={0}
                pagination
                highlightOnHover
                striped
                customStyles={TableStyle}
                onRowClicked={(row) => {
                    navigate('/edit_campaign', {state: {campaignId: row.campaignId, name:`${row.name}`, campaignStartDate:row.startDate, campaignEndDate:row.endDate, pages:row.pages, template:row.template, campaignProducts: row.products, pageTemplates: row.pageTemplates, year: row.year}});
                }}
            />
        </Container>
    );
}
 
export default CampaignTable;